import { createStyles, Theme } from '@material-ui/core'
import {
  colorWhite,
  colorWhiteAlpha05,
  colorWhiteAlpha10,
  colorWhiteAlpha12,
  colorWhiteAlpha20,
  colorWhiteAlpha30,
  colorWhiteAlpha95Text,
  transition,
} from '../../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useMainPageFaqSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordionSection: {
      position: 'relative',
      padding: theme.spacing(10, 3),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(8, 2.5),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(8, 2),
      },
    },
    sectionBgImage: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 0,
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      opacity: 0,
      transition: 'opacity 280ms ease-out',
      pointerEvents: 'none',
    },
    sectionBgImageVisible: {
      opacity: 1,
    },
    sectionBgLoader: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colorWhite,
      opacity: 1,
      transition: 'opacity 240ms ease-out',
    },
    sectionBgLoaderHidden: {
      opacity: 0,
      pointerEvents: 'none',
    },
    accordionHolder: {},
    accordionTitle: {
      textAlign: 'center',
      color: theme.palette.common.white,
      fontWeight: 700,
      fontSize: 'clamp(28px, 3.5vw + 1vh, 48px)',
      marginBottom: theme.spacing(6),
      letterSpacing: '-0.02em',
      [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(24px, 4.5vw, 40px)',
        marginBottom: theme.spacing(5),
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(22px, 5.5vw, 36px)',
        marginBottom: theme.spacing(4),
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 'clamp(20px, 6vw, 32px)',
      },
    },
    accordionBlock: {
      maxWidth: 800,
      margin: '0 auto',
      position: 'relative',
      zIndex: 3,
    },
    accordionOverlay: {
      zIndex: 1,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      background: theme.palette.primary.dark,
      opacity: 0.5,
    },
    heading: {
      fontSize: 'clamp(18px, 2vw, 28px)',
      color: theme.palette.common.white,
      fontWeight: 600,
      letterSpacing: '-0.01em',
      [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(16px, 2.5vw, 24px)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(16px, 3vw, 22px)',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 'clamp(14px, 3.5vw, 20px)',
      },
    },
    customAccordionBg: {
      background: colorWhiteAlpha05,
      boxShadow: 'none',
      border: 'none',
      borderBottom: `1px ${colorWhiteAlpha30} solid`,
      borderRadius: theme.shape.borderRadius * 2,
      marginBottom: theme.spacing(1),
      transition: transition,
      '&:before': {
        display: 'none',
      },
      '&:hover': {
        background: colorWhiteAlpha10,
        transform: 'translateX(4px)',
      },
      '&.Mui-expanded': {
        background: colorWhiteAlpha12,
        marginBottom: theme.spacing(2),
      },
    },
    customIcon: {
      color: theme.palette.common.white,
      border: `2px ${theme.palette.common.white} solid`,
      borderRadius: '50%',
      display: 'block',
      width: 36,
      height: 36,
      transition: transition,
      '&.Mui-expanded': {
        transform: 'rotate(180deg)',
        backgroundColor: colorWhiteAlpha20,
      },
      [theme.breakpoints.down('sm')]: {
        width: 32,
        height: 32,
      },
    },
    accordionText: {
      color: colorWhiteAlpha95Text,
      fontSize: 'clamp(14px, 1.2vw, 18px)',
      lineHeight: 1.8,
      padding: theme.spacing(2, 0),
      [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(13px, 1.5vw, 17px)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(13px, 1.8vw, 16px)',
      },
    },
  })
)
